import { CssBaseline, ThemeProvider } from "@mui/material";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import AppInit from "app/App/components/AppInit";
import "helpers/formats";
import reportWebVitals from "./reportWebVitals";
import store from "./rootStore";

import theme from "ui/theme";
import "ui/CountrySelect/freakflags.css";

import "moment/locale/nb";
import "moment/locale/sv";
import "moment/locale/en-gb";

import "dayjs/locale/nb";
import "dayjs/locale/en";
import "dayjs/locale/sv";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

let location = window.location.pathname.split("/");

root.render(
    // <React.StrictMode>
    <BrowserRouter basename={`${location[1]}/games`}>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <AppInit />
            </ThemeProvider>
        </Provider>
    </BrowserRouter>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
